import script from "./DesktopPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./DesktopPage.vue?vue&type=script&lang=ts&setup=true"

import "./DesktopPage.vue?vue&type=style&index=0&id=70d42e8c&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70d42e8c"]])

export default __exports__